module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-10.fea57f0a.mp3";